// Single source for cosmetic asset URLs. The version param busts the
// Cloudflare CDN cache when a stale SPA-fallback response got cached for
// /cosmetics/* before the files actually existed in the bundle. Bump this
// number if you swap asset files at the same path again.
const ASSET_VERSION = 2;

export function cosmeticUrl(assetPath: string): string {
  // Cloud-served cosmetics (badges on R2) carry a full CDN URL in asset_path —
  // use it directly. Older bundled cosmetics carry a bare filename served from
  // /cosmetics/ with a cache-busting version.
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  return `/cosmetics/${assetPath}?v=${ASSET_VERSION}`;
}
